import { css } from 'linaria';

export const productVariants = css`
  margin: 40px 0;
`;

export const prices = css`
  margin: var(--space-200) 0;
`;

export const dataIsLoadingCommon = css`
  opacity: 0.2;
  transition: opacity 0.2s ease-out;
`;

export const dataIsLoadingNoninteractive = css`
  opacity: 0.2;
  transition: opacity 0.2s ease-out;
  pointer-events: none;
`;

export const stickyMediaGallery = css`
  position: sticky;
  top: 0;
  height: inherit;
  padding: var(--space-100) 0;

  @media (--from-tablet) {
    padding: var(--space-200) 0 var(--space-100);
  }

  @media (--from-desktop) {
    padding: var(--space-200) 0 var(--space-200);
  }
`;

export const counter = css`
  height: var(--space-600) !important;
  padding: 0 var(--space-175);
`;
